<h4 class="fw-bold">
    <span class="fw-light mx-1"> {{ displayLabel }} </span>
</h4>

<div [formGroup]="metricForm">
    <div class="bg-card shadow-md rounded p-2 mb-2">
        <div class="row">
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.name' | translate"
                    [formControlName]="isArabic ? 'nameAE' : 'nameEN'"
                    [controlName]="isArabic ? 'nameAE' : 'nameEN'"
                />
            </div>
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input [label]="'metrics.label_type' | translate" formControlName="typeName" controlName="typeName" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    [label]="'metrics.label_data_type' | translate"
                    [formControlName]="isArabic ? 'dataTypeAE' : 'dataTypeEN'"
                    [controlName]="isArabic ? 'dataTypeAE' : 'dataTypeEN'"
                />
            </div>
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    [label]="'metrics.data_source' | translate"
                    [formControlName]="isArabic ? 'dataSourceAE' : 'dataSourceEN'"
                    [controlName]="isArabic ? 'dataSourceAE' : 'dataSourceEN'"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <adaa-form-input
                    [label]="'common.form.label.description' | translate"
                    [formControlName]="isArabic ? 'dscAE' : 'dscEN'"
                    [controlName]="isArabic ? 'dscAE' : 'dscEN'"
                    [isTextArea]="true"
                />
            </div>
        </div>
    </div>

    @if (!isViewMode()) {
        <div class="bg-card shadow-md rounded p-2 mb-2">
            <div class="row">
                <div class="col-sm-3 col-xs-12">
                    <adaa-form-dropdown
                        [label]="'common.form.label.month' | translate"
                        formControlName="month"
                        controlName="month"
                        [options]="months"
                    />
                </div>
                <div class="col-sm-3 col-xs-12">
                    <adaa-form-dropdown [label]="'common.form.label.year' | translate" formControlName="year" controlName="year" [options]="years" />
                </div>
                <div class="col-sm-4 col-xs-11">
                    <adaa-form-input
                        formControlName="actual"
                        controlName="actual"
                        inputType="number"
                        [label]="'forecasted_values.title_single' | translate"
                    />
                </div>
                <div class="col-sm-2 col-xs-2 pt-3 d-flex justify-content-center align-items-center">
                    @if (!editingValueId()) {
                        <button class="btn btn-primary" (click)="addMetricValue()">{{ "add" | translate }}</button>
                    } @else {
                        <button class="btn btn-primary mx-1" (click)="updateMetricValue()">{{ "common.form.button.save" | translate }}</button>
                        <button class="btn btn-danger mx-1" (click)="cancelUpdate()">{{ "common.form.button.cancel" | translate }}</button>
                    }
                </div>
            </div>
        </div>
    }
</div>

<div class="bg-card shadow-md rounded p-2 mb-2">
    <adaa-data-table
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.FORECASTED_VALUES_METRICS_EDITOR_LIST"
        [enableAdd]="false"
        [enableExport]="false"
        [enableViewAction]="false"
        [isLocalData]="true"
        [enableActionsCell]="!isViewMode()"
        [localData]="metricValues()"
        (actionClicked)="actionClicked($event)"
    />
</div>

<adaa-form-action-buttons
    [showSaveButton]="false"
    (cancelClicked)="goBack()"
    [cancelButtonTitle]="isViewMode() ? 'common.form.button.close' : 'common.form.button.cancel'"
/>
